"use client";
import React from "react";
import dynamic from "next/dynamic";
import "./index.css"
/* 🔴 Keep this STATIC (usually above the fold) */
import BannerSection from "../../common-components/banner-section/BannerSection";
import PageTitle from "@/components/common-components/page-title/PageTitle";
import DotLoaders from "@/components/common-components/DotLoaders";

/* 🟢 Dynamic – below the fold / non-critical */
const AboutSubCategories = dynamic(() => import("./AboutSubCategories"), { ssr: true });
const QuickContact = dynamic(() => import("./QuickContact"), { ssr: false, loading: () => <DotLoaders/> });
const TestimonialSection = dynamic(() => import("@/components/common-components/testimonial/TestimonialSection"), { ssr: false, loading: () => <DotLoaders/> });
const VideoSection = dynamic(() => import("./VideoSection"), { ssr: false, loading: () => <DotLoaders/> });
const SimilarCategory = dynamic(() => import("./SimilarCategory"), { ssr: false, loading: () => <DotLoaders/> });
const SubCategory = dynamic(() => import("./SubCategory"), { ssr: true });

export default function CategoriesPageComponent({
  categoryDetails,
  marketArea,
  isSubCategory = false,
}) {
  const link = categoryDetails?.category_video_link;

  return (
    <>
      <PageTitle
        title="Categories"
        image={categoryDetails?.category_banner_image}
        name={categoryDetails?.page_title}
        subTitle={
          isSubCategory
            ? categoryDetails.parent_category.page_title
            : categoryDetails?.page_title
        }
        subHref={
          isSubCategory
            ? categoryDetails.parent_category.category_slug
            : categoryDetails?.category_slug
        }
        petaTitle={isSubCategory ? categoryDetails?.page_title : ""}
        petaHref={isSubCategory ? categoryDetails?.category_slug : ""}
        marketAreaName={marketArea?.name}
        marketAreaSlug={marketArea?.slug}
        isCategory
      />
      <AboutSubCategories categoryDetails={categoryDetails} marketArea={marketArea} />
      <SubCategory categoryDetails={categoryDetails} marketArea={marketArea} isSubCategory={isSubCategory} />
      {!isSubCategory && <><BannerSection /> <SimilarCategory categoryDetails={categoryDetails} marketArea={marketArea} isSubCategory={isSubCategory} /></>}
      {link && <VideoSection link={link} />}
      <TestimonialSection />
      <QuickContact categoryDetails={categoryDetails} />
    </>
  );
}
